// pickerNote — what a <select> says when the list behind it never arrived.
//
// Lived in apps/office/records/OfficePage.js until 2026-09-04 and is moved
// here for the same reason serverSentence moved out of apps/dispatch/lib on
// 2026-09-03: apps/shared/JobForm.js needs it, and a shared module importing
// from one application is the coupling this rebuild keeps refusing elsewhere.
// JobForm's own header says it deliberately does not reach into Office's page
// helpers — so with the function over there, the one form every app opens to
// create a job was the only picker in the rebuild that could not say this.
//
// OfficePage re-exports it, so every existing caller and
// OfficePageHelpers.test.js are untouched.

/**
 * What a PICKER says when the list behind it never arrived. Pass the result to
 * a `FwField`'s `error` prop.
 *
 * `LoadError` covers a panel, and a panel that fails renders a sentence, which
 * is visibly a claim and gets questioned. A select that fails just has fewer
 * options — which looks like DATA, and nobody questions data. So the reader
 * concludes "this client is not on file" / "there are no jobs" from a request
 * that never answered, and acts on it.
 *
 * Returns null when there is no error, so a list that genuinely came back
 * empty still reads as empty rather than as a failure — that distinction is
 * the whole point and it is the easy half to delete by accident.
 *
 * @param {Error|null} error  the query error, or null
 * @param {string} what       the noun, singular: 'worker', 'job', 'client'
 */
export function pickerNote(error, what) {
  if (!error) return null;
  if (error.status === 403) return `You do not have permission to choose a ${what} here.`;
  return `The ${what} list could not be loaded, so this is empty. It is not that there are none.`;
}

export default pickerNote;
